import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
import { useRef, useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { ZodError, z } from "zod";


export function EmailRenderer() {
    const { setFormValue, disabled, response, setSubmitDisabled, currentValue } = useFieldContext();
    const [value, setValue] = useState<string>("");
    const errorRef = useRef<ZodError>();
    const schema = z.string().email("Invalid email address");

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    if (disabled) {
        return (
            <div className="">
                <p className="whitespace-pre">{response?.field_value}</p>
            </div>
        )
    } else {
        return (
            <div className="flex flex-col gap-2">
                <Input
                    type="email"
                    onChange={(e) => {
                        const value = e.target.value;
                        try {
                            schema.parse(value)
                            errorRef.current = undefined;
                            setSubmitDisabled && setSubmitDisabled(false);
                        } catch (error) {
                            errorRef.current = error as ZodError;
                            setSubmitDisabled && setSubmitDisabled(true);
                        }
                        setValue(value);
                        setFormValue(value);
                    }}
                    value={value}
                />

                <div className="flex flex-col gap-2">
                    {errorRef.current?.errors?.map((error, index) => (
                        <p key={index} className="text-sm text-red-500">{error.message}</p>
                    ))}
                </div>
            </div>
        )
    }

}
